import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom'; // Import useNavigate for redirection
import { checkIsCountryExists, createRestaurant, getRestaurant } from '../../../apis/resturants-winerise';
import { TextField, Button, Typography, Box, Backdrop, CircularProgress } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Toast } from '../../../components/alert';
import {API} from '../../../apis/constants';
import ImageUploader from '../../../components/resturaunt-wineries/ImageField';

function ResturantDetails() {
  const navigate = useNavigate(); // For redirection
  const [description, setDescription] = useState('');
  const [url, setUrl] = useState('');
  const [restaurantName, setRestaurantName] = useState('');
  const [error, setError] = useState('');
  const [location, setLocation] = useState({ lat: null, lng: null });
  const [binaryImage, setBinaryImage] = useState(null);
  const [imageError, setImageError] = useState('');
  const [countryImage, setCountryImage] = useState(null);
  const [countryImageError, setCountryImageError] = useState('');
  const [countryExist, setCountryExist] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [validationErrors, setValidationErrors] = useState({}); 
  const [countryId, setCountryId] = useState({}); 
  const [mapImage, setMapImage] = useState(''); 
  const [restaurantAdd, setRestaurantAdd] = useState('');
  const { id } = useParams(); 
  const locationInfo = useLocation();

  const searchParams = new URLSearchParams(locationInfo.search);
  useEffect(() => {
    setCountryId(searchParams.get("locId"));
  }, [locationInfo]);



  useEffect(() => {
    const fetchRestaurantDetails = async () => {
      if (id === 'new') return;
      setLoading(true);
      try {
        const response = await getRestaurant(`/api/dine/restaurants/${id}`, 'GET'); 
        if (response) {
           
          setRestaurantName(response.name || '');
          setDescription(response.description || '');
          setUrl(response.tock_link || '');
            setLocation({
            lat: response.latitude !== null ? parseFloat(response.latitude) : null,
            lng: response.longitude !== null ? parseFloat(response.longitude) : null,
            address: response.address || ''
            });
            setRestaurantAdd(response.address || '');
          if (response.image) {
            setBinaryImage({preview:response.image}); 
          }
          if (response.country_image) {
            setCountryImage(response.country_image); 
          }
        }
        setLoading(false);
      } catch (error) {
        console.error('Error fetching restaurant details:', error);
        setLoading(false);
      }
    };

    fetchRestaurantDetails();
  }, [id]);
  const handleLocationChange = async (newLocation) => {
    setRestaurantAdd(newLocation.address);
    if(newLocation.ss)setMapImage(newLocation.ss)
      if(!newLocation.countryName) return
    setLocation(newLocation);
    let isExixts = await checkIsCountryExists('/api/dine/check-country', 'GET', { name: newLocation.countryName });
    if (!isExixts.is_exist) {
      setCountryExist(true);
      return;
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!restaurantName.trim()) {
      errors.restaurantName = 'Restaurant name is required.';
    }
    if (!url.trim()) {
      errors.url = 'Tock URL is required.';
    }
    if (!description.trim()) {
      errors.description = 'Description is required.';
    }
    if (!restaurantAdd.trim()) {
      errors.restaurantAdd = 'Restaurant address  is required.';
    }
    setValidationErrors(errors);
    return Object.keys(errors).length === 0; // Return true if no errors
  };

  const handleFieldChange = (field, value) => {
    setValidationErrors((prevErrors) => ({
      ...prevErrors,
      [field]: '', 
    }));

    switch (field) {
      case 'restaurantName':
        setRestaurantName(value);
        break;
      case 'restaurantAdd':
        setRestaurantAdd(value);
        break;
      case 'url':
        setUrl(value);
        const urlRegex =  /^(https?):\/\/(?:[A-Za-z0-9-]+\.)+[A-Za-z]{2,6}(?::\d{1,5})?(?:\/\S*)?$/;
        if (!urlRegex.test(value)) {
          setValidationErrors((prevErrors) => ({
            ...prevErrors,
            url: 'Please enter a valid URL.',
          }));
        }
        break;
      case 'description':
        setDescription(value);
        break;
      default:
        break;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return; 
    }
    
    setSubmitting(true); 
    let formData = new FormData();
    
    formData.append('description', description);
    formData.append('tock_link', url);
    formData.append('latitude', location.lat);
    formData.append('longitude', location.lng);
    formData.append('address', restaurantAdd);
    formData.append('country_name', searchParams.get("locname") || '');
    formData.append('map_snap', mapImage);
    formData.append('name', restaurantName);
    formData.append('country_id', countryId);
    if (binaryImage && !binaryImage?.preview) {
      formData.append('image', binaryImage);
    }
    if (countryImage) {
      formData.append('country_image', countryImage);
    }
    try {
      if(id == 'new'){
        await createRestaurant('/api/dine/restaurants', 'POST', formData);
        Toast('success','Restaurant is created successfully')
      }else{
        formData.append('_method', 'PUT');
       
        await createRestaurant(`/api/dine/restaurants/${id}`, 'POST', formData);
        Toast('success','Restaurant is updated successfully')
      }
      navigate(-1); 
    } catch (error) {
      Toast('error', error)
    } finally {
      setSubmitting(false); 
    }
  };

  return (
    <Box
      sx={{
        width: '100%',
        padding: 3,
        backgroundColor: '#f9f9f9',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '2rem' }}>
        <Typography
          variant="h4"
          align="left"
          gutterBottom
          style={{ cursor: 'pointer' }}
          onClick={() => window.history.back()} 
        >
          <ArrowBackIcon />
        </Typography>
        <Typography variant="h4" align="center" gutterBottom>
          Restaurant
        </Typography>
      </div>
      <form onSubmit={handleSubmit}>
       
        
        { !loading && (

        <Box sx={{ marginBottom: 3, width: '100%', marginTop: '5rem', position: 'relative' }} style={{marginTop: '100px'}} >
          <ImageUploader
            height={400}
            width={600}
            label="Upload Restaurant Image"
            type="restaurant"
            RestaurantId={id}
            binaryImage={binaryImage ?  binaryImage : ''}
            errorProp={validationErrors.image}
            onChange={(data, error) => {
              if (error) {
                setImageError(error);
                setBinaryImage(null);
              } else {
                 setImageError('');
                setBinaryImage(data.file);
              }
            }}
          />
         
        </Box>
        )

        }
        {countryExist && (
          <Box sx={{ marginBottom: 3, width: '100%', marginTop: '5rem' }}>
            <ImageUploader
              label="Upload Country Image"
              type="country"
              onChange={(data, error) => {
                if (error) {
                  setCountryImageError(error);
                  setCountryImage(null);
                } else {
                  setCountryImageError('');
                  setCountryImage(data.file);
                }
              }}
            />
          </Box>
        )}
        <Box sx={{ marginBottom: 3, width: '100%', marginTop: '5rem' }} >
        <TextField
            label="Restaurant Address"
            fullWidth
            variant="outlined"
            value={restaurantAdd}
            onChange={(e) => handleFieldChange('restaurantAdd', e.target.value)}
            placeholder="Enter restaurant address"
            error={!!validationErrors.restaurantAdd}
            helperText={validationErrors.restaurantAdd}
          />
        </Box>
        <Box sx={{ marginBottom: 3, width: '100%', marginTop: '5rem' }}>
        
          <TextField
            label="Restaurant name"
            fullWidth
            variant="outlined"
            value={restaurantName}
            onChange={(e) => handleFieldChange('restaurantName', e.target.value)}
            placeholder="Enter restaurant name"
            error={!!validationErrors.restaurantName}
            helperText={validationErrors.restaurantName}
          />
        </Box>
        <Box sx={{ marginBottom: 3, width: '100%', marginTop: '5rem' }}>
          <TextField
            label="Tock URL"
            fullWidth
            variant="outlined"
            value={url}
            onChange={(e) => handleFieldChange('url', e.target.value)}
            placeholder="Enter restaurant tock URL"
            error={!!validationErrors.url}
            helperText={validationErrors.url}
          />
        </Box>

        <Box sx={{ marginBottom: 3, width: '100%', marginTop: '5rem' }}>
          <TextField
            label="Description"
            multiline
            rows={4}
            fullWidth
            variant="outlined"
            value={description}
            onChange={(e) => handleFieldChange('description', e.target.value)}
            placeholder="Enter restaurant description"
            error={!!validationErrors.description}
            helperText={validationErrors.description}
          />
        </Box>
        <Button
          type="submit"
          variant="contained"
          sx={{
            backgroundColor: '#C84B96',
        color: '#fff',
        borderRadius: 2,
        textTransform: 'capitalize',
        '&:hover': {
            backgroundColor: '#9B3A73', // Darker shade of the current color
        }
          }}
          fullWidth
          disabled={submitting} // Disable button while submitting
        >
          Submit
        </Button>
      </form>

      {/* Backdrop for loading */}
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={submitting} 
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
}

export default ResturantDetails;